module.exports = __webpack_public_path__ + "static/ppf-2-123f85ecbf294abc8b46649ce7a2b192.jpg";